import { render } from "./InfoUser.vue?vue&type=template&id=405ddd44&scoped=true"
import script from "./InfoUser.vue?vue&type=script&lang=js"
export * from "./InfoUser.vue?vue&type=script&lang=js"

import "./InfoUser.vue?vue&type=style&index=0&id=405ddd44&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-405ddd44"]])

export default __exports__